import { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash-es/debounce';
import i18nContext from 'components/i18n-context';
import { CONVERA_FILE_TYPE } from 'components/constants';
import CustomSearchInput from 'components/CustomSearchInput';
import { CustomDatePicker } from 'uikit/CustomDatePicker';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './ConveraStatementsFiltersBar.scss';

const ConveraStatementsFiltersBar = ({ filters, totalElements, handleSetFilters }) => {
  const i18n = useContext(i18nContext);
  const currentDate = new Date();
  const [filenameValue, setFilenameValue] = useState(filters.filename || '');

  const debouncedSearch = useRef(
    debounce((name, value) => {
      handleSetFilters(name, value);
    }, 400)
  ).current;

  const handleFilenameInputChange = ({ target: { name, value } }) => {
    setFilenameValue(value);

    debouncedSearch(name, value);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const fileTypeOptions = Object.keys(CONVERA_FILE_TYPE).map((key) => {
    return {
      key: CONVERA_FILE_TYPE[key],
      value: CONVERA_FILE_TYPE[key]
    };
  });

  return (
    <div className={'convera-statements-filters-wrapper'}>
      <div className={'convera-statements-date-range-filters-wrapper'}>
        <div>
          <span>{i18n.getMessage('converaStatements.filter.createdFrom.label')}</span>
          <CustomDatePicker
            onChange={handleSetFilters}
            name={'createdFrom'}
            value={filters.createdFrom}
            maxDate={filters.createdTo || currentDate}
          />
        </div>
        <div>
          <span>{i18n.getMessage('converaStatements.filter.createdTo.label')}</span>
          <CustomDatePicker
            onChange={handleSetFilters}
            name={'createdTo'}
            value={filters.createdTo}
            maxDate={currentDate}
            minDate={filters.createdFrom}
          />
        </div>
      </div>

      <InputDropDown
        className={'convera-statements-filter-wrapper'}
        label={i18n.getMessage('converaStatements.filter.type.label')}
        name={'type'}
        value={filters.type}
        options={fileTypeOptions}
        onChange={handleSetFilters}
        isMulti
      />
      <CustomSearchInput
        wrapperClassName={'search-wrapper'}
        inputClassName={'convera-statements-filter-wrapper'}
        label={i18n.getMessage('converaStatements.filter.filename.label')}
        placeholder={i18n.getMessage('converaStatements.filter.filename.placeholder')}
        name={'filename'}
        value={filenameValue}
        onChange={handleFilenameInputChange}
        totalElements={totalElements}
      />
    </div>
  );
};

ConveraStatementsFiltersBar.propTypes = {
  filters: PropTypes.object,
  totalElements: PropTypes.number,
  handleSetFilters: PropTypes.func
};

export default ConveraStatementsFiltersBar;
